import iconTemplate from './IconTemplate.jsx';

export default iconTemplate(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 14 14"
        id="Earth-1--Streamline-Flex"
    >
        <desc>{'Earth 1 Streamline Icon: https://streamlinehq.com'}</desc>
        <g id="earth-1--planet-earth-globe-world">
            <path
                id="Vector"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M7 13.5c4.16 0 6.5 -2.34 6.5 -6.5S11.16 0.5 7 0.5 0.5 2.84 0.5 7s2.34 6.5 6.5 6.5Z"
                strokeWidth={1}
            />
            <path
                id="Vector_2"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m10.9701 12.0755 -0.0012 0.4117m0 0c1.6472 -1.061 2.5312 -2.93032 2.5312 -5.48717 0 -0.02243 -0.0001 -0.0448 -0.0002 -0.06712l-0.0572 -0.03233c-1.146 -0.59434 -3.95194 -0.87954 -4.94339 0.11191 -0.32533 0.32533 -0.5081 0.76658 -0.5081 1.22667 0 0.46009 0.18277 0.90134 0.5081 1.22667 0.32534 0.32533 0.76658 0.5081 1.22667 0.5081 0.32862 0 0.64382 0.13057 0.87622 0.36297 0.2324 0.2323 0.3629 0.5475 0.3629 0.8762v1.2766l0.0038 -0.0025Z"
                strokeWidth={1}
            />
            <path
                id="Vector_3"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M4.01357 8.97015c0.32533 -0.32534 0.5081 -0.76658 0.5081 -1.22667V6.25653c0 -0.46009 0.18277 -0.90134 0.50811 -1.22667 0.32533 -0.32533 0.76658 -0.5081 1.22667 -0.5081 0.46009 0 0.90133 -0.18277 1.22667 -0.50811 0.83776 -0.83776 0.70313 -2.2949 0.5081 -3.466254C7.67337 0.515896 7.34287 0.5 7 0.5 2.84 0.5 0.5 2.84 0.5 7c0 0.91622 0.113509 1.74415 0.33497 2.47825 1.12753 0.54425 2.39054 0.27996 3.1786 -0.5081Z"
                strokeWidth={1}
            />
        </g>
    </svg>,
);
